<template>
  <div style="background:#fff; padding:20px;">
    <div style="margin-bottom: 20px">
      <a-button type="primary" icon="plus" @click="handleAdd(0)">新增顶级菜单</a-button>
      <a-button type="default" icon="reload" style="margin-left:10px" @click="loadData">刷新</a-button>
    </div>

    <a-table 
      :columns="columns" 
      :data-source="data" 
      rowKey="id" 
      :loading="loading" 
      :pagination="false"
      defaultExpandAllRows
      :indentSize="30"
    >
      <span slot="type" slot-scope="text">
        <a-tag v-if="text===0" color="blue">目录</a-tag>
        <a-tag v-else-if="text===1" color="green">菜单</a-tag>
        <a-tag v-else color="orange">按钮</a-tag>
      </span>

      <span slot="icon" slot-scope="text">
        <a-icon v-if="text" :type="text" /> {{ text }}
      </span>

      <span slot="action" slot-scope="text, record">
        <a @click="handleEdit(record)">编辑</a>
        <a-divider type="vertical" />
        <a @click="handleAdd(record.id)">新增子项</a>
        <a-divider type="vertical" />
        <a-popconfirm title="确定要删除吗? 如果有子菜单将无法删除。" @confirm="handleDelete(record.id)">
          <a style="color: red">删除</a>
        </a-popconfirm>
      </span>
    </a-table>

    <a-modal 
      v-model="visible" 
      :title="form.id ? '编辑菜单' : '新增菜单'" 
      @ok="handleOk"
    >
      <a-form-model :model="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 16 }">
        <a-form-model-item label="上级ID" v-if="form.parentId !== 0">
           <a-input v-model="form.parentId" disabled />
        </a-form-model-item>
        
        <a-form-model-item label="类型">
          <a-radio-group v-model="form.type">
            <a-radio :value="0">目录</a-radio>
            <a-radio :value="1">菜单</a-radio>
            <a-radio :value="2">按钮</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item label="标题">
          <a-input v-model="form.title" placeholder="例如：系统管理" />
        </a-form-model-item>

        <a-form-model-item label="路由Path">
          <a-input v-model="form.path" placeholder="例如: system (不带 / )" />
        </a-form-model-item>

        <template v-if="form.type === 1">
          <a-form-model-item label="组件路径">
            <a-input v-model="form.component" placeholder="例如: system/user/index" />
          </a-form-model-item>
        </template>

        <template v-if="form.type === 0 || (form.type === 1 && form.parentId === 0)">
          <a-form-model-item label="图标">
            <a-input v-model="form.icon" placeholder="例如: setting" />
            <a href="https://1x.antdv.com/components/icon-cn/" target="_blank" style="font-size:12px">参考图标库</a>
          </a-form-model-item>
        </template>

        <a-form-model-item label="权限标识" v-if="form.type === 2">
          <a-input v-model="form.permission" placeholder="例如: user:add" />
        </a-form-model-item>

        <a-form-model-item label="排序">
          <a-input-number v-model="form.sortOrder" :min="0" style="width:100%" />
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
    // 引入我们刚才定义的 API
    import { getMenuList, saveMenu, deleteMenu } from '@/api'

    export default {
        data() {
            return {
                data: [],
                loading: false,
                visible: false,
                // 表单数据
                form: {
                    type: 1,
                    sortOrder: 0,
                    parentId: 0
                },
                columns: [
                    { title: '菜单标题', dataIndex: 'title', width: '20%' },
                    { title: '图标', dataIndex: 'icon', scopedSlots: { customRender: 'icon' } },
                    { title: '组件路径', dataIndex: 'component' },
                    { title: '路由Path', dataIndex: 'path' },
                    { title: '排序', dataIndex: 'sortOrder' },
                    { title: '类型', dataIndex: 'type', scopedSlots: { customRender: 'type' }, width: '100px' },
                    { title: '操作', key: 'action', scopedSlots: { customRender: 'action' }, width: '250px' }
                ]
            }
        },
        created() {
            this.loadData()
        },
        methods: {
            // 加载数据
            loadData() {
                this.loading = true
                getMenuList().then(res => {
                    this.data = res.data
                    this.loading = false
                })
            },

            // 点击新增
            handleAdd(parentId) {
                // 重置表单，注意这里我们要使用 驼峰命名 (parentId, sortOrder)
                this.form = {
                    id: null, // id 为 null 代表新增
                    parentId: parentId,
                    type: 1,
                    sortOrder: 0,
                    title: '',
                    path: '',
                    component: '',
                    icon: ''
                }
                this.visible = true
            },

            // 点击编辑
            handleEdit(record) {
                // 浅拷贝当前行数据到表单
                this.form = { ...record }
                // 确保 children 字段不被带入提交，虽然传了也没事，但为了干净
                delete this.form.children 
                this.visible = true
            },

            // 点击删除
            handleDelete(id) {
                deleteMenu({ id: id }).then(res => {
                    this.$message.success('删除成功')
                    this.loadData()
                })
            },

            // 提交表单
            handleOk() {
                // 简单的表单校验
                if (!this.form.title) {
                    this.$message.error('请输入菜单标题')
                    return
                }
                if (!this.form.path && this.form.type !== 2) {
                     this.$message.warning('建议填写路由Path')
                }

                saveMenu(this.form).then(() => {
                    this.$message.success('操作成功')
                    this.visible = false
                    this.loadData()
                })
            }
        }
    }
</script>